import React, { useEffect, useState } from "react";
import { services } from "./data";
import "./services.css";
import { Link, NavLink } from "react-router-dom";
import { LazyLoadImage } from "react-lazy-load-image-component";
import "react-lazy-load-image-component/src/effects/blur.css";

const Services = () => {
  const [activeIndex, setActiveIndex] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setActiveIndex((prevIndex) => (prevIndex + 1) % services.length);
    }, 5000);
    return () => clearInterval(interval);
  }, [activeIndex]);

  const handleClick = (index, interval) => {
    setActiveIndex(index);
    clearInterval(interval);
    window.scrollTo(0, 0);
  };

  const handleLinkClick = () => {
    window.scrollTo(0, 0);
  };

  function highlightWords(text, wordsToBold) {
    const regex = new RegExp(`(${wordsToBold.join("|")})`, "gi");
    const parts = text.split(regex);
    return parts.map((part, index) =>
      wordsToBold.includes(part) ? (
        <span key={index} className="highlighted-word">
          {part}
        </span>
      ) : (
        part
      )
    );
  }

  return (
    <section className="page services">
      <div className="services-container">
        <div className="services-left">
          <div className="text-wrapper">
            <h1>
              Step Up To Explore Our
              <span className="title-word">Services</span>
            </h1>
            <p>
              Choose from our comprehensive packages or select individual
              services to suit your needs. Browse through options like Social
              Media Management, Content Creation, Video Editing, Graphic Design,
              SEO, UI/UX, and more—each crafted to elevate your brand and engage
              your target audience effectively.
            </p>
            <p>
              Choose from our comprehensive packages or select individual
              services to suit your needs. Browse through options like
              <span className="desc-word"> Social Media Management </span>,
              <span className="desc-word">Content Creation </span>,
              <span className="desc-word">Video Editing </span>,
              <span className="desc-word">Graphic Design </span>,
              <span className="desc-word">SEO </span>,
              <span className="desc-word">UI/UX </span>, and more—each crafted
              to elevate your brand and engage your target audience effectively.
            </p>
          </div>
        </div>
        <div className="services-right">
          {services.map((service, index) => (
            <NavLink to={service.link} key={service.id}>
              <div
                className={`box ${activeIndex === index ? "active" : ""}`}
                onClick={() => handleClick(index)}
              >
                <div className="headline">
                  <h2>{service.title}</h2>
                  <div className="svg-box">{service.svg}</div>
                </div>
                <p>{highlightWords(service.description, service.boldWords)}</p>
                <p className="discount">
                  Save up to <span className="desc-word">10</span>% by choosing
                  this bundle!
                </p>
              </div>
            </NavLink>
          ))}
        </div>
      </div>
      <div className="individual-serv">
        <div className="title">
          <h2>Individual Services</h2>
        </div>
        <div className="individual-serv-cards">
          <div className="serv-card">
            <div className="imag-box">
              <LazyLoadImage
                src={require("../../assets/blog-details-sec-2.jpg")}
                alt="UI/UX Picture"
                effect="blur"
              />
            </div>
            <div className="text-box">
              <h4>UI/UX Design</h4>
              <p>
                We'll make sure your website or app looks great and offers a
                seamless user experience to boost engagement and conversions.
              </p>
              <Link to="/webDesign" onClick={handleLinkClick}>
                <button className="btn">Explore Service</button>
              </Link>
            </div>
          </div>
          <div className="serv-card">
            <div className="imag-box">
              <LazyLoadImage
                src={require("../../assets/blog-5.jpg")}
                alt="SEO & SEM Picture"
                effect="blur"
              />
            </div>
            <div className="text-box">
              <h4>SEO & SEM</h4>
              <p>
                Improve our online presence to increase search engine rankings
                and attract targeted visitors through paid and organic
                strategies.
              </p>
              <Link to="/seo" onClick={handleLinkClick}>
                <button className="btn">Explore Service</button>
              </Link>
            </div>
          </div>
          <div className="serv-card">
            <div className="imag-box">
              <LazyLoadImage
                src={require("../../assets/blog-4.jpg")}
                alt="Video Editing Picture"
                effect="blur"
              />
            </div>
            <div className="text-box">
              <h4>Video Editing</h4>
              <p>
                Professionally edit videos with effects and transitions to
                create eye-catching visual content
              </p>
              <Link to="/videoEditing" onClick={handleLinkClick}>
                <button className="btn">Explore Service</button>
              </Link>
            </div>
          </div>
          <div className="serv-card">
            <div className="imag-box">
              <LazyLoadImage
                src={require("../../assets/blog-details-sec-2.jpg")}
                alt="Content Creation Picture"
                effect="blur"
              />
            </div>
            <div className="text-box">
              <h4>Content Creation</h4>
              <p>
                Design visual and textual content that aligns with your brand
                voice and appeals to your audience.
              </p>
              <Link to="/contectCreation" onClick={handleLinkClick}>
                <button className="btn">Explore Service</button>
              </Link>
            </div>
          </div>
          <div className="serv-card">
            <div className="imag-box">
              <LazyLoadImage
                src={require("../../assets/blog-5.jpg")}
                alt="Graphic Design Picture"
                effect="blur"
              />
            </div>
            <div className="text-box">
              <h4>Graphic Design</h4>
              <p>
                Design engaging visuals that enhance your brand message and
                engage your audience.
              </p>
              <Link to="/graphicDesign" onClick={handleLinkClick}>
                <button className="btn">Explore Service</button>
              </Link>
            </div>
          </div>
          <div className="serv-card">
            <div className="imag-box">
              <LazyLoadImage
                src={require("../../assets/blog-4.jpg")}
                alt="Social Media Management Picture"
                effect="blur"
              />
            </div>
            <div className="text-box">
              <h4>Social Media Management</h4>
              <p>
                Strategically manage our social media presence to increase
                engagement, grow followers, and enhance brand awareness.
              </p>
              <Link to="/socialMedia" onClick={handleLinkClick}>
                <button className="btn">Explore Service</button>
              </Link>
            </div>
          </div>
          <div className="serv-card">
            <div className="imag-box">
              <LazyLoadImage
                src={require("../../assets/blog-5.jpg")}
                alt="Motion Graphics Picture"
                effect="blur"
              />
            </div>
            <div className="text-box">
              <h4>Motion Graphics</h4>
              <p>
                Create animations and visual effects that add a modern touch to
                our stories and help tell them creatively.
              </p>
              <Link to="/motionGraphic" onClick={handleLinkClick}>
                <button className="btn">Explore Service</button>
              </Link>
            </div>
          </div>
          <div className="serv-card">
            <div className="imag-box">
              <LazyLoadImage
                src={require("../../assets/blog-details-sec-2.jpg")}
                alt="SEO & SEM Picture"
                effect="blur"
              />
            </div>
            <div className="text-box">
              <h4>SEO & SEM</h4>
              <p>
                Improve our online presence to increase search engine rankings
                and attract targeted visitors through paid and organic
                strategies.
              </p>
              <Link to="/seo" onClick={handleLinkClick}>
                <button className="btn">Explore Service</button>
              </Link>
            </div>
          </div>
          <div className="serv-card">
            <div className="imag-box">
              <LazyLoadImage
                src={require("../../assets/blog-4.jpg")}
                alt="Printing Services Picture"
                effect="blur"
              />
            </div>
            <div className="text-box">
              <h4>Printing Services</h4>
              <p>
                Printed materials remain essential for creating tangible brand
                touchpoints, leaving a lasting impression
              </p>
              <Link to="/seo" onClick={handleLinkClick}>
                <button className="btn">Explore Service</button>
              </Link>
            </div>
          </div>
          <div className="serv-card">
            <div className="imag-box">
              <LazyLoadImage
                src={require("../../assets/blog-details-sec-2.jpg")}
                alt="Social Media Advertising Picture"
                effect="blur"
              />
            </div>
            <div className="text-box">
              <h4>Paid Social Media Advertising</h4>
              <p>
                Run targeted advertising campaigns on social platforms to reach
                our ideal audience, increase engagement, and achieve the highest
                ROI.
              </p>
              <Link to="/mediaAds" onClick={handleLinkClick}>
                <button className="btn">Explore Service</button>
              </Link>
            </div>
          </div>
        </div>
      </div>
      {/* <Outlet /> */}
    </section>
  );
};

export default Services;
